/**
 * Deployment mode utilities for the web application
 *
 * Determines whether the system should interact with Kubernetes (EKS) or Docker containers.
 * Uses VITE_USE_HELM environment variable as the feature flag.
 */

// Lazy evaluation - check environment once and cache the result
let _isKubernetesMode: boolean | null = null;

/**
 * Determines if the system is running in Kubernetes mode (EKS)
 *
 * @returns true if USE_HELM is set to "true", false otherwise
 */
export const isKubernetesMode = (): boolean => {
  if (_isKubernetesMode === null) {
    _isKubernetesMode = import.meta.env.VITE_USE_HELM === "true";
  }
  return _isKubernetesMode;
};

/**
 * Alias for isKubernetesMode() for backward compatibility
 *
 * @returns true if system is in EKS mode, false otherwise
 */
export const isEKSMode = (): boolean => {
  return isKubernetesMode();
};

/**
 * Determines if the system is running in Docker mode
 *
 * @returns true if NOT in Kubernetes mode, false otherwise
 */
export const isDockerMode = (): boolean => {
  return !isKubernetesMode();
};
